import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormikValues } from 'formik';
import ForgotPasswordForm from '../../components/templates/form-forgot-password';
import ConfirmForm from '../../components/templates/confirm-form';
import { ResetPasswordSelectors, ResetPasswordActions } from '../../common/config/store';
import Layout from '../../components/templates/layout';
import Card from '../../components/molecules/card';
import { useIntl } from '../../common/config/i18n';

const ForgotPassword: React.FC = () => {
  const { t } = useIntl();
  const dispatch = useDispatch();
  const status = useSelector(ResetPasswordSelectors.statusSelector);
  const onSubmitHandler = (values: FormikValues) => {
    dispatch(ResetPasswordActions.sendEmail(values.email));
  };
  return (
    <div>
      <Layout login />
      <Card title={t('form', 'FORM_FORGOT_PASSWORD_TITLE')}>
        <>
          {status !== 'success' && <ForgotPasswordForm onSubmit={onSubmitHandler} status={status} />}
          {status === 'success' && <ConfirmForm message={t('form', 'TEMPORARY_PASSWORD_EMAIL_SENT')} />}
        </>
      </Card>
    </div>
  );
};
export default ForgotPassword;
